import classNames from 'classnames'
import { JSX } from 'react'

import { FormDropdown } from 'cng-common/features/form'
import { IFormDropdownProps } from 'cng-common/features/form/components/formDropdown/models'
import { createComponentFn } from 'onboarding/components/helpers/createComponentFn'
import themesStyles from 'onboarding/components/themes.module.scss'

type TComponentFn<T> = (props: IFormDropdownProps<T>) => JSX.Element | null

const applyDisabled = <T,>(component: TComponentFn<T>) => {
  return (props: IFormDropdownProps<T>) => {
    const { isDisabled, classes } = props
    const disabledTheme = isDisabled ? themesStyles.disabledDropdown : undefined

    return component({
      ...props,
      classes: {
        ...classes,
        inputClasses: {
          ...classes?.inputClasses,
          root: classNames(classes?.inputClasses?.root, disabledTheme),
        },
      },
    })
  }
}

export const OnboardingFormDropdown = <T,>(props: IFormDropdownProps<T>) =>
  applyDisabled(createComponentFn<IFormDropdownProps<T> & JSX.IntrinsicAttributes>(FormDropdown))(
    props
  )
